import { useEffect, useLayoutEffect } from 'react';

// The build writes a static copy of each public page beside #root
// (scripts/prerender.mjs) so crawlers and link previews read real content.
// Once React has its own copy in the DOM the static one goes — in a layout
// effect, before the browser paints, so the two never share a frame.
const useIsomorphicLayoutEffect = typeof document === 'undefined' ? useEffect : useLayoutEffect;

export function hasPrerenderedPage() {
  return typeof document !== 'undefined' && Boolean(document.getElementById('prerendered-page'));
}

export function usePrerenderHandoff() {
  useIsomorphicLayoutEffect(() => {
    document.getElementById('prerendered-page')?.remove();
  }, []);
}
